// Çerçeve görseli (700x1000) 9 parçalı çizilir: süslü köşeler her kart boyutunda aynı kalır,
// sadece düz kenarlar ve orta doku uzar. Eskiden görselin tamamı %100x%100 gerildiği için
// geniş/kısa kartlarda köşe süsleri yassılaşıyor, uzun pencerelerde uzuyordu.
// border-width 0: çerçeve sayfa düzenini (iç boşluk, boyut) değiştirmez.
export const authCardStyle = {
  borderStyle: 'solid',
  borderWidth: 0,
  borderImageSource: 'url("/image/menu/arkaplan1.png")',
  borderImageSlice: '195 205 200 205 fill',
  borderImageWidth: 'clamp(64px, 12vw, 120px)',
  borderImageRepeat: 'stretch',
  colorScheme: 'only light',
};

export const authButtonStyle = {
  backgroundImage: 'url("/image/menu/butonuzun1.png")',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
};

export const authButtonSmallStyle = {
  backgroundImage: 'url("/image/menu/buton1.png")',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
};

export const pullMonstersButtonStyle = {
  backgroundImage: 'url("/image/menu/canavarcek.png")',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
};

// textbox1uzun.png (300x70) 9 parçalı: köşe süsleri (~16px) sabit kalır, kenar ve orta uzar.
export const textboxFrameStyle = {
  borderStyle: 'solid',
  borderWidth: 0,
  borderImageSource: 'url("/image/menu/textbox1uzun.png")',
  borderImageSlice: '16 fill',
  borderImageWidth: '16px',
  borderImageRepeat: 'stretch',
};

export const authStatPanelStyle = textboxFrameStyle;

export const villageCardCenterStyle = {
  backgroundImage: 'url("/image/menu/arkaplan1-sadece-ortasi.png")',
  backgroundSize: '100% 100%',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
};
